import axios from 'axios';
import { req } from './axiosFun';

// 百度 获取 access_token
export const identificationRecognize = (params) => { return req("post", "/baiduOCR/oauth/2.0/token", params) };

// 上传图片 识别问题
export const idCardIdentify = (params) => { return req("post", "/baiduOCR/rest/2.0/ocr/v1/idcard", params) };



// WEBPACK FOOTER //
// ./src/api/baidu.js